import React from 'react';
export const About = () => {
  return <section className="w-full py-10 px-6 md:px-10 bg-[#f5f5f0] relative overflow-hidden" data-id="element-22">
      <div className="max-w-[1400px] mx-auto relative z-10" data-id="element-23">
        <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-24">
          {/* Left - Main content */}
          <div className="space-y-6" data-id="element-25">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-26">
              Обо мне
            </h2>
            <div className="space-y-5 text-base text-gray-700 leading-relaxed" data-id="element-27">
              <p data-id="element-28">
                Меня зовут Мария, я клинический психолог и член Ассоциации
                экзистенциально-аналитических психологов. В своей работе я
                опираюсь на экзистенциальный и когнитивно-поведенческий подходы,
                дополняя их телесными, арт- и фокусинговыми практиками.
              </p>
              <p data-id="element-29">
                В психологию я пришла в 2019 году, имея первое образование в
                сфере финансового менеджмента. Разные профессиональные сферы
                сформировали у меня одновременно структурный, ориентированный на
                результат взгляд и глубокое понимание эмоциональных процессов.
              </p>
              <p data-id="element-30">
                Моё обучение психологии продолжается уже более шести лет — это
                путь, который я прохожу с интересом и любовью. Я регулярно
                учусь, прохожу супервизии и, что важно, сама остаюсь в личной
                терапии. Это помогает мне быть чуткой, присутствующей и надёжной
                для тех, кто приходит ко мне.
              </p>
            </div>
          </div>
          {/* Right - Credentials card */}
          <div data-id="element-31">
            <div className="bg-white rounded-[32px] p-10 border border-gray-200 relative overflow-hidden shadow-lg" data-id="element-32">
              <div className="space-y-8 relative z-10" data-id="element-33">
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-gray-900 mb-5" data-id="element-35">
                    Мои подходы
                  </h3>
                  <div className="space-y-3" data-id="element-36">
                    <div className="bg-gradient-to-r from-[#f0f7f2] to-[#f5f9f6] border-l-4 border-[#3d8f5a] rounded-lg p-4" data-id="element-37">
                      <p className="text-gray-800 font-semibold text-sm" data-id="element-38">
                        Экзистенциальная психотерапия
                      </p>
                    </div>
                    <div className="bg-gradient-to-r from-[#f0f7f2] to-[#f5f9f6] border-l-4 border-[#3d8f5a] rounded-lg p-4" data-id="element-39">
                      <p className="text-gray-800 font-semibold text-sm" data-id="element-40">
                        Когнитивно-поведенческая терапия
                      </p>
                    </div>
                  </div>
                </div>
                <div className="space-y-5 pt-4" data-id="element-41">
                  <div data-id="element-42">
                    <div className="text-3xl font-bold text-[#3d8f5a]" data-id="element-43">5+</div>
                    <div className="text-gray-600 font-medium text-sm" data-id="element-44">
                      лет консультирования
                    </div>
                  </div>
                  <div data-id="element-45">
                    <div className="text-3xl font-bold text-[#3d8f5a]" data-id="element-46">
                      2760+
                    </div>
                    <div className="text-gray-600 font-medium text-sm" data-id="element-47">
                      часов проведённых сессий
                    </div>
                  </div>
                  <div data-id="element-48">
                    <div className="text-3xl font-bold text-[#3d8f5a]" data-id="element-49">
                      280+
                    </div>
                    <div className="text-gray-600 font-medium text-sm" data-id="element-50">
                      часов личной терапии
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};